<template>
  <v-container style="max-width: 100%">
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-img class='align-center' :src="require('@/assets/images/sub.jpg')">
          <div class="text-center white--text py-5">
            <div class="text-sm-h3 pt-5 font-weight-bold" style="font-size: 1.5rem">인피니티 사람들</div>
            <div class="text-sm-h5 py-5" style="font-size: 1.0rem">인피니티투자자문의 사람들을 소개합니다.</div>
          <!-- <div class='text-center white--text'><span class="sub_01">인피니티 사람들</span><br>
          <span class="sub_02">인피니티투자자문의 사람들을 소개합니다.</span></div> -->
          </div>
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">

        <v-tabs
          v-model="model"
          centered
          slider-color="white"
          color="white"
          background-color="red darken-4"
          dark
          active-class="white red--text"
          replace
        >
          <v-tab
            v-for="(menu, i) in menus"
            :key="i"
            :href="`#tab-${i+1}`"
          >
            {{menu.title}}
          </v-tab>
        </v-tabs>

        <v-container>
          <div :class="$vuetify.breakpoint.mobile ? 'col-12 pa-0' : 'col-8 mx-auto'">
            <v-tabs-items v-model="model">
              <v-tab-item
                v-for="(menu, i) in menus"
                :key="i"
                :value="`tab-${i+1}`"
                eager
              >
                <v-row class="pa-1 justify-space-between">
                  <v-col cols="auto"
                    v-for="(card, j) in menu.list"
                    :key="j"
                  >
                    <v-card
                      :class="$vuetify.breakpoint.mobile ? 'px-0' : 'px-10'"
                      class="mx-auto pt-5"
                      :style="menu.list.length == 1 ? 'width: 1140px; height: 340px;' : 'width: 558px; height: 340px;'"
                      color="#F5F5F5"
                      title="Icons"
                      subtitle="prepend-icon and append-icon"
                      prepend-icon="mdi-account"
                      append-icon="mdi-check"
                    >
                      <v-card-title class="font-weight-black text-h4 my-1">
                        {{ card.name }} <span class="px-3 pt-3 font-weight-bold" style="font-size: 1.3rem;"> {{ card.position }}</span>
                      </v-card-title>
                      <v-card-text>
                        <span class="font-weight-bold" :style="$vuetify.breakpoint.mobile ? 'font-size: 0.9rem;' : 'font-size: 1.1rem;'" v-html="card.text"></span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  const DEPT_ORDER = ['CEO', '운용본부', 'AI본부', '고객자산본부', '경영본부'];

  export default {
    data: () => ({
      model: '',
      menus: []
      /*
      menus: [
        {
          title: 'CEO',
          img: require('@/assets/images/menu4-1.jpg'),
          list: [{ name: '나홍규', Position: '대표이사', text: T1_NHG }]
        },
        {
          title: '운용본부',
          img: require('@/assets/images/menu4-2.jpg'),
          list: [
            { name: '나홍규', Position: '대표이사', text: T1_NHG },
            { name: '은효상/운용역', Position: '부사장' , text: T2_EHS },
            { name: '서진원', Position: '부사장', text: T2_SJW },
            { name: '이건재', Position: '대리', text: T2_LGJ },
            { name: '김지은', Position: '사원', text: T2_KJE }
          ]
        },
        {
          title: 'AI본부',
          img: require('@/assets/images/menu4-3.jpg'),
          list: [
            { name: '강보미', Position: '대리', text: T3_KBM },
            { name: '이어령', Position: '사원', text: T3_LEY }
          ]
        },
        {
          title: '경영본부',
          img: require('@/assets/images/menu4-4.jpg'),
          list: [
            { name: '손명숙/운용지원', Position: '실장', text: T4_SMS },
            { name: '윤한규', Position: '실장', text: T4_YHK }
          ]
        }
      ],
      */
    }),
    created() {
      this.$http.get(`${process.env.VUE_APP_API_URL}/getEmpInfo`)
        .then(response => {
          if (response.status === 200) {
            this.menus = this.makeMenus(response.data);
          }
        })
        .catch(error => {
          console.error("API 요청 실패:", error);
          this.menus = [];
        });
    },
    mounted() {
      this.model = this.$route.query.page;
    },
    methods: {
      makeMenus(rows) {
        const deptMap = {};

        rows.forEach(row => {
          if (!deptMap[row.DEPT_NAME]) {
            deptMap[row.DEPT_NAME] = {
              title: row.DEPT_NAME,
              list: []
            };
          }

          deptMap[row.DEPT_NAME].list.push({
            name: row.EMP_NAME,
            position: row.POSITION,
            text: row.DESCRIPTION,
            img: row.IMG_PATH
          });
        });

        // ⭐ 탭 순서 고정
        return DEPT_ORDER
          .filter(dept => deptMap[dept])   // 존재하는 부서만
          .map(dept => deptMap[dept]);
      }
    }
  }
/*
  //@@@@@@@@@@ CEO @@@@@@@@@@//
  // 나홍규
  const T1_NHG = `
  <p> - 굿모닝투신 펀드매니저 조사팀장</p>
  <p> - 삼성증권 코스닥 팀장(Head of KOSDAQ Research)</p>
  <p> - 동방페레그린증권 화학 도소매 담당 애널리스트</p>
  <p> - 대우경제연구소 화학 담당 애널리스트</p>
  <p> - 연세대학교 본대학원 경영학과 재무관리 석사</p>`;

  //@@@@@@@@@@ 운용본부 @@@@@@@@@@//
  // 은효상/운용역
  const T2_EHS = `
  <p> - 기업리서치(주)</p>
  <p> - 오크우드투자자문</p>
  <p> - 마이터투자자문</p>
  <p> - KDB자산운용</p>
  <p> - 연세대학교 대학원 경제학과</p>`;

  // 2025.06.16 - 권이삭/운용역 삭제
  // const T2_GIS = `
  // <p> - 제브라투자자문</p>
  // <p> - 부산대학교 생명과학과</p>`;

  // 서진원(2025.09.06)
  const T2_SJW = `
  <p> - Invescope Priavte Equity</p>
  <p> - 미래에셋증권</p>
  <p> - ㈜크레버스</p>
  <p> - 케이비인베스트먼트㈜</p>
  <p> - University of llinois, Finance, Accountacny 석사</p>`;
  // 이건재
  const T2_LGJ = `
  <p> - 인피니티글로벌자산운용</p>
  <p> - 한양대학교 경영학과</p>`;

  // 김지은
  const T2_KJE = `
  <p> - 숭실대학교 경영학부</p>`;
  // 2024.02.07 - 이건재/애널리스트 삭제
  // const T2_LGJ = `
  // <p> - 한양대학교 경경학과</p>`;

  // 2024.11.21 - 이다인/트레이더 사원 삭제
  // const T2_LDI = `
  // <p> - 숙명여자대학교 미디어학부</p>`;

  //@@@@@@@@@@ AI본부 @@@@@@@@@@//
  // 이어령
  const T3_LEY = `
  <p> - 숭실대학교 경영학부</p>`;

  // 강보미
  const T3_KBM = `
  <p> - 인피니티글로벌자산운용</p>
  <p> - 숭실대학교 경영학부</p>`;

  //@@@@@@@@@@ 경영본부 @@@@@@@@@@//
  // 손명숙/운용지원
  const T4_SMS = `
  <p> - 삼성증권</p>
  <p> - 동방페레그린증권</p>
  <p> - 신한금융투자</p>`;

  // 윤한규
  const T4_YHK = `
  <p> - 신영증권</p>
  <p> - KB국민은행</p>
  <p> - 우리은행</p>`;
*/
</script>

<style>
.v-tabs{
  margin-bottom: 80px;
}
.v-tab.v-tab{
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0rem;
  padding: 0 60px;
}
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--dark.v-tabs > .v-tabs-bar .v-tab--disabled{
  color: #ffffff !important;
}
.sub_01{
  font-size:3.375rem ;
  font-weight: 700;
}
.sub_02{
  font-size:1.625rem;
}
</style>

